(ns practitest.frontend.components2.unsaved-changes-confirmation-modal
  (:require [practitest.frontend.common.i18n :refer [get-translation]]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components.modal :as modal]
            [practitest.frontend.components2.buttons :as buttons]))

(defn unsaved-changes-confirmation-modal [{:keys [show? container-ref on-close on-confirm]}]
  [modal/bootstrap-modal
   {:is-open?         show?
    :container-ref    container-ref
    :on-request-close on-close
    :centered?        true
    :class            "integration-cancel-confirm-modal"}
   nil
   [:<>
    [:div.header
     (get-translation "sections.notify.confirm-cancel-title" "Unsaved changes")
     [:span.close-button {:on-click on-close}
      [icons/mux-x]]]
    [:p.description
     (get-translation "sections.notify.confirm-cancel"
                      "Are you sure you want to cancel? All unsaved changes will be lost.")]
    [:div.modal-footer
     [buttons/button
      {:text     (get-translation "view-editor.cancel" "Cancel")
       :on-click on-close}]
     [buttons/button
      {:text     (get-translation "global-fields.migration.confirmation.approve" "Approve")
       :primary? true
       :on-click on-confirm}]]]
   nil])
